/* =========================================================
   Nonprofits & community organizations.

   ONE source of truth: HubOrgs.jsx renders the hub section from
   this list, and HubQuickActions.jsx builds its Community Connect
   links from it too.

   Fields per org:
     id          short slug · also the logo filename: upload the
                 logo to the CDN as img/orgs/<id>.png and it
                 appears (initials show until then)
     name        organization name
     community   community slug as your app uses it; this drives
                 the "next upcoming event" chip through events'
                 community_slug. An empty value shows no event chip.
     communityLabel  chip text
     about       one-line description for the detail card
     website / facebook / instagram   official https:// links (optional)
     email       public contact email published by the organization
                 (optional)
     logo        optional explicit image URL (overrides the CDN)

   IMPORTANT:
     Review every non-empty community value against the exact
     community_slug values used by your events data.
   ========================================================= */

const HUB_ORGS = [
  {
    id: "aitscm",
    name: "American Indians in Texas at the Spanish Colonial Missions (AIT-SCM)",
    community: "native-american",
    communityLabel: "Native American",
    about:
      "Preserves Indigenous culture and supports Native American families in San Antonio.",
    website: "https://aitscm.org/",
    facebook: "https://www.facebook.com/americanindiansintexas/",
    instagram: "https://www.instagram.com/aitscm/",
    email: "aitinfo@aitscm.org",
  },
  {
    id: "aacn",
    name: "Arab American Community Network (AACN)",
    community: "arab",
    communityLabel: "Arab",
    about:
      "Community network supporting and connecting Arab Americans in San Antonio.",
    website: "https://aacommunitynetwork.org/",
    facebook: "https://www.facebook.com/aacnorgtx/",
    instagram: "https://www.instagram.com/aacnorg/",
  },
  {
    id: "afghans-sa",
    name: "Afghans in San Antonio",
    community: "afghan",
    communityLabel: "Afghan",
    about:
      "Community organization supporting Afghan families in the San Antonio area.",
    website: "https://afghansinsa.org/",
  },
  {
    id: "ameleb",
    name: "Ameleb Club of San Antonio",
    community: "lebanese",
    communityLabel: "Lebanese",
    about:
      "Lebanese American social and cultural club serving San Antonio.",
    website: "https://amelebclub.com/",
    email: "amelebclubsa@gmail.com",
  },
  {
    id: "mehr",
    name: "Mehr Foundation (San Antonio Persian Cultural Society)",
    community: "persian",
    communityLabel: "Persian",
    about:
      "Nonprofit celebrating and promoting Persian and Iranian arts and culture.",
    website: "https://www.mehrfoundationsa.org/",
    facebook: "https://www.facebook.com/mehrfoundationsa/",
    instagram: "https://www.instagram.com/mehrfoundationsa/",
    email: "mehrfoundationsa@gmail.com",
  },
  {
    id: "taasa",
    name: "Turkish American Association of San Antonio (TAA-SA)",
    community: "turkish",
    communityLabel: "Turkish",
    about:
      "Cultural and educational nonprofit connecting San Antonio with Turkish heritage.",
    website: "https://taa-sa.org/",
  },
  {
    id: "raindrop",
    name: "Raindrop Foundation San Antonio",
    community: "turkish",
    communityLabel: "Turkish",
    about:
      "Educational and cultural nonprofit promoting dialogue and cross-cultural friendship.",
    website: "https://www.raindropsanantonio.org/",
    facebook: "https://www.facebook.com/RaindropSanAntonio/",
    email: "info@raindropsanantonio.org",
  },
  {
    id: "culturingua",
    name: "Culturingua",
    community: "",
    communityLabel: "MENASA",
    about:
      "Community and economic development organization serving San Antonio's Silk Road Cultural Heritage District.",
    website: "https://www.culturingua.com/",
    facebook: "https://www.facebook.com/Culturingua/",
    instagram: "https://www.instagram.com/culturingua/",
    email: "nader@culturingua.com",
  },
  {
    id: "sfslac",
    name: "Southern Federation of Syrian Lebanese American Clubs",
    community: "lebanese",
    communityLabel: "Syrian & Lebanese",
    about:
      "Regional federation connecting Syrian and Lebanese American clubs and communities.",
    website: "https://www.sfslac.org/",
    email: "sfslac@sfslac.org",
  },
  {
    id: "arab-sa",
    name: "Arab San Antonio",
    community: "arab",
    communityLabel: "Arab",
    about:
      "Community resource platform for Arab residents and families in San Antonio.",
    website: "https://arab-sanantonio.com/en/about",
  },
  {
    id: "mena-sa",
    name: "MENA SA",
    community: "",
    communityLabel: "MENA women",
    about:
      "Middle East and North Africa women's community collective in San Antonio.",
    facebook: "https://www.facebook.com/MENATX/",
  },
  {
    id: "refugee-services",
    name: "Center for Refugee Services",
    community: "",
    communityLabel: "Refugee support",
    about:
      "Helps legally resettled refugees build self-sufficient lives in San Antonio.",
    website: "https://sarefugees.org/",
    facebook: "https://www.facebook.com/centerefugeeservices/",
    instagram: "https://www.instagram.com/crs_satx/",
  },
  {
    id: "anuja",
    name: "Anuja SA",
    community: "indian",
    communityLabel: "Indian",
    about:
      "Nonprofit promoting the sister-city relationship between San Antonio and Chennai.",
    website: "https://www.anujasa.com/",
    facebook: "https://www.facebook.com/AnujaSanAntonio/",
    instagram: "https://www.instagram.com/anujasanantonio/",
  },
  {
    id: "bengali",
    name: "San Antonio Bengali Cultural Community (SABCC)",
    community: "bengali",
    communityLabel: "Bengali",
    about:
      "Nonprofit preserving and celebrating Bengali culture in San Antonio.",
    website: "https://sanantoniobcc.org/",
    facebook: "https://www.facebook.com/sabcc/",
    instagram: "https://www.instagram.com/connectsabcc/",
    email: "sabcc.info@gmail.com",
  },
  {
    id: "gujarati-samaj",
    name: "Gujarati Samaj of San Antonio",
    community: "gujarati",
    communityLabel: "Gujarati",
    about:
      "Nonprofit preserving Gujarati language, traditions and culture in San Antonio.",
    website: "https://www.gssatx.org/",
    facebook: "https://www.facebook.com/Gujaratisamajofsanantonio/",
    email: "info@gssatx.org",
  },
  {
    id: "india-assn",
    name: "India Association of San Antonio",
    community: "indian",
    communityLabel: "Indian",
    about:
      "Umbrella nonprofit promoting Indian culture, heritage and community connection.",
    website: "https://indiasa.org/",
    facebook: "https://www.facebook.com/IndiaSA/",
    email: "contact@indiasa.org",
  },
  {
    id: "kannada-sangha",
    name: "Kuvempu Kannada Sangha of San Antonio",
    community: "indian",
    communityLabel: "Kannada",
    about:
      "Nonprofit promoting Karnataka's language, culture and heritage in San Antonio.",
    website: "https://www.kks-sa.org/",
    email: "kannadasanghaofsa@gmail.com",
  },
  {
    id: "suma",
    name: "San Antonio United Malayalee Association (SUMA)",
    community: "indian",
    communityLabel: "Malayalee",
    about:
      "Nonprofit preserving Kerala heritage and supporting San Antonio's Malayalee community.",
    website: "https://sumaonline.org/",
    facebook: "https://www.facebook.com/SanAnotonioMalayalee/",
    instagram: "https://www.instagram.com/suma.sanantonio/",
    email: "suma@sumaonline.org",
  },
  {
    id: "mauc",
    name: "Mexican American Unity Council (MAUC)",
    community: "mexican",
    communityLabel: "Mexican American",
    about:
      "Community development nonprofit focused on housing, education and economic opportunity.",
    website: "https://www.mauc.org/",
    facebook: "https://www.facebook.com/mauc.org/",
    email: "info@mauc.org",
  },
  {
    id: "saaacam",
    name:
      "San Antonio African American Community Archive and Museum (SAAACAM)",
    community: "african-american",
    communityLabel: "African American",
    about:
      "Preserves and shares San Antonio's African American history and cultural heritage.",
    website: "https://saaacam.org/",
    facebook: "https://www.facebook.com/SAAACAM/",
    instagram: "https://www.instagram.com/saaacamtx/",
    email: "admin@saaacam.org",
  },
  {
    id: "ethnic-art",
    name: "San Antonio Ethnic Art Society (SAEAS)",
    community: "african-american",
    communityLabel: "African Diaspora arts",
    about:
      "Nonprofit advancing Black and African Diaspora artists in the San Antonio area.",
    website: "https://www.saethnicartsociety.org/",
    facebook:
      "https://www.facebook.com/p/San-Antonio-Ethnic-Art-Society-61568950583656/",
    instagram: "https://www.instagram.com/saeas.art/",
    email: "saeas.tx@gmail.com",
  },
  {
    id: "tamil-sangam",
    name: "San Antonio Tamil Sangam",
    community: "indian",
    communityLabel: "Tamil",
    about:
      "Community organization promoting Tamil language, culture and connection in San Antonio.",
    website: "https://satamilsangam.org/",
    facebook: "https://www.facebook.com/sanantonio.tamilsangam/",
  },
  {
    id: "urban-indian",
    name: "Urban Indian SA",
    community: "native-american",
    communityLabel: "Native American",
    about:
      "Community organization supporting urban Native American people in San Antonio.",
    website: "https://urbanindiansa.net/",
  },

  // Additional verified San Antonio organizations.
  {
    id: "aaasa",
    name: "Asian American Alliance of San Antonio (AAASA)",
    community: "asian",
    communityLabel: "Asian American",
    about:
      "Umbrella alliance connecting and promoting Asian American organizations in San Antonio.",
    website: "https://www.aaasatx.org/",
    facebook: "https://www.facebook.com/AsianAllianceSA/",
    instagram: "https://www.instagram.com/aaasatx/",
    email: "aaasa.info@gmail.com",
  },
  {
    id: "asian-resource-center",
    name: "Asian Resource Center of San Antonio",
    community: "asian",
    communityLabel: "Asian American",
    about:
      "Resource and community center serving Asian communities in San Antonio.",
    website: "https://asiancentersa.org/",
    facebook: "https://www.facebook.com/ARCSanAntonio/",
    instagram: "https://www.instagram.com/arcsanantonio/",
    email: "info@asiancentersa.org",
  },
  {
    id: "caca-sa",
    name: "Chinese American Citizens Alliance, San Antonio Lodge",
    community: "chinese",
    communityLabel: "Chinese American",
    about:
      "Local lodge supporting Chinese American civil rights, service and civic participation.",
    website: "https://www.cacasatx.org/",
    facebook: "https://www.facebook.com/groups/cacasatx/",
  },
  {
    id: "chinese-society",
    name: "Chinese Society of San Antonio",
    community: "chinese",
    communityLabel: "Chinese",
    about:
      "Community organization promoting Chinese culture and connection in San Antonio.",
    website: "https://www.sachinese.org/",
    facebook: "https://www.facebook.com/ChineseSocietySA/",
    instagram: "https://www.instagram.com/chinesesocietysa/",
    email: "chinesesocietysa@gmail.com",
  },
  {
    id: "chinese-alliance",
    name: "San Antonio Chinese Alliance",
    community: "chinese",
    communityLabel: "Chinese",
    about:
      "Charitable and educational organization serving San Antonio's Chinese community.",
    website: "https://www.sa-chinese.org/",
    facebook: "https://www.facebook.com/SAChineseAlliance/",
    email: "sacamember@gmail.com",
  },
  {
    id: "jassa",
    name: "Japan-America Society of San Antonio (JAS-SA)",
    community: "japanese",
    communityLabel: "Japanese",
    about:
      "Nonprofit connecting San Antonio and Japan through cultural and business exchange.",
    website: "https://jas-sa.org/",
    facebook: "https://www.facebook.com/JASSA.TX/",
    instagram: "https://www.instagram.com/jas_sanantonio/",
  },
  {
    id: "kaccsa",
    name: "Korean American Cultural Center of San Antonio (KACCSA)",
    community: "korean",
    communityLabel: "Korean",
    about:
      "Cultural center supporting Korean heritage and community programs in San Antonio.",
    website: "https://www.sakorean.org/",
    facebook: "https://www.facebook.com/KACCSA/",
    instagram: "https://www.instagram.com/sakorean/",
    email: "info@sakorean.org",
  },
  {
    id: "cabsat",
    name: "Communities Aligning Baguio and San Antonio Texas (CABSAT)",
    community: "filipino",
    communityLabel: "Filipino",
    about:
      "Supports the San Antonio-Baguio sister-city relationship through cultural, educational and civic exchange.",
    website: "https://cabsat.org/",
    facebook: "https://www.facebook.com/100092410897856/",
  },
  {
    id: "telugu-assn",
    name: "Telugu Association of San Antonio (TASA)",
    community: "indian",
    communityLabel: "Telugu",
    about:
      "Nonprofit serving the cultural, social and literary needs of San Antonio's Telugu community.",
    website: "https://www.tasatexas.org/",
    facebook: "https://www.facebook.com/100068233753996/",
    email: "info@tasatexas.org",
  },
  {
    id: "taiwanese-assn",
    name: "Taiwanese Association of America, San Antonio Chapter (TAASA)",
    community: "taiwanese",
    communityLabel: "Taiwanese",
    about:
      "Local chapter connecting and celebrating San Antonio's Taiwanese American community.",
    website:
      "https://www.taa-usa.org/recipes/taiwanese-association-of-america-san-antonio",
    facebook: "https://www.facebook.com/taasa.tx/",
    instagram: "https://www.instagram.com/taasa_2022/",
  },
  {
    id: "jewish-federation",
    name: "Jewish Federation of San Antonio",
    community: "jewish",
    communityLabel: "Jewish",
    about:
      "Federation supporting Jewish life, services and community connection in San Antonio.",
    website: "https://www.jfsatx.org/",
    facebook: "https://www.facebook.com/JFSATX/",
    instagram: "https://www.instagram.com/jfsatx/",
    email: "jewishfederation@jfsatx.org",
  },
  {
    id: "samfco",
    name: "San Antonio-Mexico Friendship Council (SAMFCO)",
    community: "mexican",
    communityLabel: "Mexico-San Antonio",
    about:
      "Strengthens cultural, educational and civic ties between San Antonio and Mexico.",
    website: "https://samfco.org/",
    facebook: "https://www.facebook.com/samfco.org/",
    email: "info@samfco.com",
  },
  {
    id: "cida-sa",
    name: "Canary Islands Descendants Association (CIDA)",
    community: "",
    communityLabel: "Canary Islander heritage",
    about:
      "Preserves the history and heritage of San Antonio's Canary Islands descendants.",
    website: "https://cida-sa.org/",
    facebook: "https://www.facebook.com/cida.satx/",
    email: "cida.satx@gmail.com",
  },
  {
    id: "scottish-society",
    name: "Scottish Society of San Antonio",
    community: "scottish",
    communityLabel: "Scottish",
    about:
      "Community organization preserving and sharing Scottish heritage in San Antonio.",
    website: "https://scottishsociety-sa.org/",
    facebook:
      "https://www.facebook.com/p/The-Scottish-Society-of-San-Antonio-100064390821294/",
    instagram:
      "https://www.instagram.com/scottish_society.sanantonio/",
  },
  {
    id: "alliance-francaise",
    name: "Alliance Française de San Antonio",
    community: "french",
    communityLabel: "French",
    about:
      "Nonprofit promoting French language and Francophone cultures in San Antonio.",
    website: "https://www.afsanantonio.org/",
    facebook: "https://www.facebook.com/afsanantonio/",
    instagram: "https://www.instagram.com/afsanantonio/",
    email: "alliance@afsanantonio.org",
  },
  {
    id: "harp-shamrock",
    name: "Harp & Shamrock Society of Texas",
    community: "irish",
    communityLabel: "Irish",
    about:
      "San Antonio nonprofit promoting Irish heritage, culture and community.",
    website: "https://harpandshamrock.org/",
    facebook: "https://www.facebook.com/harpandshamrock/",
    instagram: "https://www.instagram.com/harpshamrocktx/",
    email: "info@harpandshamrock.org",
  },
  {
    id: "beethoven-maennerchor",
    name: "Beethoven Männerchor",
    community: "german",
    communityLabel: "German",
    about:
      "Cultural organization preserving German music, language and traditions in San Antonio.",
    website: "https://beethovensanantonio.com/",
    facebook: "https://www.facebook.com/the.Beethoven/",
    instagram: "https://www.instagram.com/beethovensatx/",
    email: "contact@beethovensanantonio.com",
  },
  {
    id: "musical-bridges",
    name: "Musical Bridges Around the World",
    community: "",
    communityLabel: "Global arts",
    about:
      "Connects communities through multicultural music, education and public arts programs.",
    website: "https://musicalbridges.org/",
    facebook:
      "https://www.facebook.com/MusicalBridgesAroundTheWorld/",
    instagram: "https://www.instagram.com/musicalbridges/",
  },
  {
    id: "pan-african",
    name: "Pan African Cultural Community",
    community: "african",
    communityLabel: "Pan-African",
    about:
      "Celebrates African cultures through arts, education and community programs in San Antonio.",
    website: "https://paccommunity.com/",
    facebook: "https://www.facebook.com/PanAfricanCommunity/",
    instagram: "https://www.instagram.com/panafricancultural/",
  },
  {
    id: "esperanza-center",
    name: "Esperanza Peace and Justice Center",
    community: "",
    communityLabel: "Arts & justice",
    about:
      "Grassroots arts and cultural organization advancing social justice and cross-cultural understanding.",
    website: "https://esperanzacenter.org/",
    facebook: "https://www.facebook.com/EsperanzaCenter/",
    instagram: "https://www.instagram.com/esperanzacenter/",
  },
  {
    id: "guadalupe-cultural-arts",
    name: "Guadalupe Cultural Arts Center",
    community: "mexican",
    communityLabel: "Chicano & Latino arts",
    about:
      "Community arts center cultivating Chicano, Latino and Native American arts and culture.",
    website: "https://guadalupeculturalarts.org/",
    facebook:
      "https://www.facebook.com/guadalupeculturalartscenter/",
    instagram:
      "https://www.instagram.com/guadalupeculturalarts/",
    email: "info@guadalupeculturalarts.org",
  },
  {
    id: "macri",
    name: "Mexican American Civil Rights Institute (MACRI)",
    community: "mexican",
    communityLabel: "Mexican American",
    about:
      "Museum and institute preserving and advancing Mexican American civil-rights history.",
    website: "https://somosmacri.org/",
    facebook: "https://www.facebook.com/SomosMACRI/",
    instagram: "https://www.instagram.com/somosmacri/",
    email: "info@somosmacri.org",
  },
  {
    id: "san-anto-cultural-arts",
    name: "San Anto Cultural Arts",
    community: "mexican",
    communityLabel: "Westside arts",
    about:
      "Community-based arts nonprofit supporting youth and public art on San Antonio's West Side.",
    website: "https://www.sananto.org/",
    facebook: "https://www.facebook.com/SanAntoCulturalArts/",
    instagram: "https://www.instagram.com/sanantoculturalarts/",
    email: "info@sananto.org",
  },
  {
    id: "fiesta-youth",
    name: "Fiesta Youth",
    community: "lgbtq",
    communityLabel: "LGBTQ+ youth",
    about:
      "Provides support, education and community for LGBTQ+ youth and young adults.",
    website: "https://www.fiesta-youth.org/",
    facebook: "https://www.facebook.com/FiestaYouth/",
    instagram: "https://www.instagram.com/fiestayouth/",
    email: "info@fiesta-youth.org",
  },
  {
    id: "pride-center-sa",
    name: "Pride Center San Antonio",
    community: "lgbtq",
    communityLabel: "LGBTQ+",
    about:
      "Connects LGBTQ+ people and families with support, services and community resources.",
    website: "https://pridecentersa.org/",
    facebook: "https://www.facebook.com/pridecentersa/",
    instagram: "https://www.instagram.com/pridecentersa/",
    email: "info@pridecentersa.org",
  },
  {
    id: "raices",
    name: "RAICES",
    community: "",
    communityLabel: "Immigrant legal services",
    about:
      "San Antonio-based nonprofit providing legal and social services to immigrants and refugees.",
    website: "https://raicestexas.org/",
    facebook: "https://www.facebook.com/raicestexas/",
    instagram: "https://www.instagram.com/raicestexas/",
  },
  {
    id: "american-gateways",
    name: "American Gateways",
    community: "",
    communityLabel: "Immigration support",
    about:
      "Provides immigration legal services, education and advocacy in San Antonio and Central Texas.",
    website: "https://www.americangateways.org/",
    facebook: "https://www.facebook.com/americangateways/",
    instagram: "https://www.instagram.com/americangateways/",
  },
];

export default HUB_ORGS;